(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  const summaryAccordion = document.querySelector('.bggle_table-of-content');
  const summaryAccordionTitle = summaryAccordion?.querySelector('h2');
  const summaryAccordionContent = summaryAccordion?.querySelector('.fd--column');
  const summaryAccordionButtonHtml = '<div class="accordion_icon active"></div >';

  summaryAccordionTitle.insertAdjacentHTML('beforeend', summaryAccordionButtonHtml);
  handleSummaryAccordion();
  summaryAccordionTitle.addEventListener('click', (e) => handleSummaryAccordion(e));

  function handleSummaryAccordion(e) {
    const accordionIcon = summaryAccordionTitle.querySelector('.accordion_icon');

    if (e) {
      accordionIcon.classList.toggle('active');
    }

    if (accordionIcon.classList.contains('active')) {
      summaryAccordionContent.style.maxHeight = summaryAccordionContent.scrollHeight + 'px';
    } else {
      summaryAccordionContent.style.maxHeight = '0px';
    }
  }

  } catch(e) { console.error(e); }
})();
})();
